document.documentElement.classList.add('cp-js');

document.addEventListener('DOMContentLoaded', () => {
  const revealItems = document.querySelectorAll('[data-cp-reveal]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-cp-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-cp-main-image]');
    const mainImage = main?.querySelector('img');
    if (!main || !mainImage) return;
    gallery.querySelectorAll('[data-cp-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const source = thumb.dataset.image;
        if (!source || source === mainImage.src) return;
        main.classList.add('is-changing');
        gallery.querySelectorAll('[data-cp-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
        window.setTimeout(() => {
          mainImage.src = source;
          mainImage.srcset = '';
          mainImage.alt = thumb.dataset.alt || mainImage.alt;
          main.classList.remove('is-changing');
        }, 140);
      });
    });
  });

  document.querySelectorAll('.cp-product-gallery').forEach((gallery) => {
    const main = gallery.querySelector('.cp-product-main-media');
    const mainImage = main?.querySelector('img');
    if (!main || !mainImage) return;
    const thumbs = gallery.querySelectorAll('a.cp-product-thumb');
    thumbs.forEach((thumb, index) => {
      if (index === 0) thumb.classList.add('is-active');
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        const source = thumb.href;
        if (!source) return;
        thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (source === mainImage.src) return;
        main.classList.add('is-changing');
        const preload = new Image();
        preload.onload = () => {
          mainImage.src = source;
          mainImage.srcset = '';
          mainImage.alt = thumb.querySelector('img')?.alt || mainImage.alt;
          main.classList.remove('is-changing');
        };
        preload.onerror = () => main.classList.remove('is-changing');
        preload.src = source;
      });
    });
  });

  document.querySelectorAll('[data-cp-before-after]').forEach((comparison) => {
    const range = comparison.querySelector('input[type="range"]');
    if (!range) return;
    const update = () => comparison.style.setProperty('--cp-ba-position', `${range.value}%`);
    range.addEventListener('input', update);
    update();
  });

  document.querySelectorAll('.cp-faq').forEach((faq) => {
    faq.querySelectorAll('details').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        faq.querySelectorAll('details[open]').forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  });

  document.querySelectorAll('[data-cp-catalog]').forEach((catalog) => {
    const buttons = catalog.querySelectorAll('[data-cp-filter]');
    const cards = catalog.querySelectorAll('[data-cp-category]');
    const empty = catalog.querySelector('[data-cp-empty]');
    if (!buttons.length || !cards.length) return;

    const applyFilter = (filter) => {
      let visible = 0;
      cards.forEach((card) => {
        const categories = (card.dataset.cpCategory || '').split(' ');
        const show = filter === 'all' || categories.includes(filter);
        card.classList.toggle('is-hidden', !show);
        if (show) visible += 1;
      });
      buttons.forEach((button) => button.classList.toggle('is-active', button.dataset.cpFilter === filter));
      if (empty) empty.classList.toggle('is-visible', visible === 0);
      const url = new URL(window.location.href);
      if (filter === 'all') url.searchParams.delete('categoria'); else url.searchParams.set('categoria', filter);
      window.history.replaceState({}, '', url);
    };

    buttons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.cpFilter)));
    const requested = new URL(window.location.href).searchParams.get('categoria');
    const allowed = Array.from(buttons).map((button) => button.dataset.cpFilter);
    applyFilter(allowed.includes(requested) ? requested : 'all');
  });
});